import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from "query-string";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import Search from "../../components/Search/index";
import { getOrganizations } from "../../actions/organizationsActions";
import { getOrganization } from "../../actions/organizationActions";

const style = () => ({
    dialogContent: {
        minWidth: 300,
    },
    organizationChipWrapper: {
        margin: 8,
    },
});

export class OrganizationSketchOrderFilterDialog extends Component {
    state = {
        selectedOrganization: null,
    };

    async componentDidMount() {
        const queryParams = queryString.parse(this.props.location.search);
        const { organizationId } = queryParams;

        if (!organizationId) {
            return null;
        }

        const result = await this.props.dispatch(getOrganization(organizationId));
        if (result.response) {
            this.setState({
                selectedOrganization: result.response,
            });
        } else {
            this.setState({
                selectedOrganization: result.response,
            });
        }
    }

    searchOrganizations = async (searchValue) => {
        await this.props.dispatch(getOrganizations(1, searchValue));
    };

    renderOrganization = (organization) => (
        <ListItem key={organization.id} button onClick={() => this.selectOrganization(organization)}>
            <ListItemText primary={organization.name}/>
        </ListItem>
    );

    selectOrganization = (organization) => {
        this.setState({ selectedOrganization: organization })
    };

    removeOrganization = () => {
        this.setState({ selectedOrganization: null });
    };

    applyOrganizationFilter = async () => {
        const { selectedOrganization } = this.state;
        const organizationId = selectedOrganization ? selectedOrganization.id : undefined;
        this.props.onApplyClick(organizationId);
    };

    render() {
        return (
            <Dialog open={this.props.open} fullScreen={this.props.fullScreen}>
                <DialogTitle>
                    Filter By Organization
                </DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <Search onSearch={this.searchOrganizations} />
                    {
                        this.state.selectedOrganization &&
                        <div className={this.props.classes.organizationChipWrapper}>
                            <Chip
                                label={this.state.selectedOrganization.name}
                                onDelete={this.removeOrganization}
                            />
                        </div>
                    }
                    {
                        this.props.isFetching &&
                        <CircularProgress />
                    }
                    <List>
                        {this.props.organizations.map(this.renderOrganization)}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onDismissClick}>
                        Dismiss
                    </Button>
                    <Button onClick={this.applyOrganizationFilter} color="secondary">
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

OrganizationSketchOrderFilterDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    open: PropTypes.bool,
    organizations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    })).isRequired,
    isFetching: PropTypes.bool.isRequired,
    onApplyClick: PropTypes.func.isRequired,
    onDismissClick: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        dialogContent: PropTypes.string.isRequired,
        organizationChipWrapper: PropTypes.string.isRequired,
    }).isRequired,
};

OrganizationSketchOrderFilterDialog.defaultProps = {
    open: false,
};

const mapStateToProps = (state) => {
    const { organizations: organizationsStore } = state;
    const { organizations, isFetching } = organizationsStore;
    return {
        organizations,
        isFetching,
    };
};

export default withRouter(connect(mapStateToProps)(withMobileDialog()(withStyles(style)(OrganizationSketchOrderFilterDialog))));
